angular.module('admin.services', [])

  .factory('AccountService', ['API_VARS', 'APP_CONFIG', '$http', '$q', '$state', 'HelperService', 'UtilService', '$cookies', function(API_VARS, APP_CONFIG, $http, $q, $state, helpers, utils, $cookies){

    function handleResponse(response){
      if(utils.isValidResponse(response))
        return response.data;
      else
        return $q.reject(helpers.parseAPIError(response));
    };

    function handleError(response){
      return $q.reject(helpers.parseAPIError(response))
    };

    return {
      set: function(agent){
        // Fix for agent cookies growing too large for browsers.
        var agentInfo = _.omit(agent, ['disclaimer', 'disclaimer_html'])
        $cookies.putObject('agent', agentInfo, {path:'/', expires: moment().add(API_VARS.loginTTL, 'day').format()});
        $http.defaults.headers.common.Authorization = agent.access_token;
      },

      getAgentId: function(){
        return this.getAgent('id');
      },

      getAgent: function(field){
        var agent = $cookies.getObject('agent') || {};

        if(field)
          return agent[field];
        else
          return agent;
      },

      hasFeature: function(feature){
        const agent = $cookies.getObject('agent') || { features: [] };
        return _.contains(agent.features, feature);
      },

      initIntercom: function(){
        if(!window.Intercom) return;

        if(this.hasBootedIntercom) return;

        var agent = this.getAgent();

        if(_.isEmpty(agent)) return;

        var created = agent.created ? moment(agent.created) : moment();
        created = created.unix();

        var hasPhoto = agent.photo && agent.photo.indexOf('default-photo') === -1;

        var acceptedLegalAt = agent.legalAcceptedAt ? moment(agent.legalAcceptedAt).unix() : null;

        var opts = {
          accepted_legal_at: acceptedLegalAt,
          admin_url: `https://www.homebotapp.com/admin/agent/${agent.id}/clients`,
          app_id: APP_CONFIG.intercomId,
          avatar: {
            type: 'avatar',
            image_url: agent.photo
          },
          cospo_count: agent.cospoCount,
          created_at: created,
          digests_enabled: agent.digestsEnabled,
          email: agent.email,
          has_cospo: agent.hasCosponsorship,
          has_photo: hasPhoto,
          name: `${agent.first_name} ${agent.last_name}`,
          pending_outgoing_invite: agent.hasPendingOutgoingInvite,
          source: agent.source,
          total_clients: agent.totalClients,
          type: agent.type,
          user_id: agent.id,
          welcome_emails: agent.welcomeEmailsEnabled,
        };

        Intercom('boot', opts);

        this.hasBootedIntercom = true;
      },

      shutdownIntercom: function(){
        this.hasBootedIntercom = false;

        if(window.Intercom)
          Intercom('shutdown');
      }

    };
  }])

  .factory('AgentService', ['API_VARS', '$http', '$q', 'HelperService', 'AdminApiHelperService', function(API_VARS, $http, $q, helpers, apiHelpers){
    var service = new BaseAPIFactory('agents', API_VARS, $http, $q, helpers, apiHelpers);

    service.realEstateAgents = function(id, mlsset){
      var params = {};

      if(mlsset)
        params.mlsset = mlsset;

      return $http
        .get(API_VARS.path+'/agents/'+id+'/realEstateAgents', {params: params})
        .then(apiHelpers.handleResponse)
        .catch(apiHelpers.handleError);
    };

    service.sendAll = function(agentId){
      if(!agentId) return $q.reject('Agent Id is required');

      return $http
        .get(API_VARS.path+'/agents/' + agentId + '/sendAll')
        .then(apiHelpers.handleResponse)
        .catch(apiHelpers.handleError);
    };

    service.importClients = function(agentId){
      return $http
        .post(API_VARS.path+'/agents/'+agentId+'/buildHomesForAgent')
        .then(apiHelpers.handleResponse)
        .catch(apiHelpers.handleError);
    };

    service.getSponsor = function(agentId){
      return $http
        .get(API_VARS.path+'/agents/'+agentId+'/sponsor')
        .then(apiHelpers.handleResponse)
        .catch(apiHelpers.handleError);
    };

    service.getSponsoredAgents = function(agentId){
      return $http
        .get(API_VARS.path+'/agents/'+agentId+'/sponsoredAgents')
        .then(apiHelpers.handleResponse)
        .catch(apiHelpers.handleError);
    };

    service.getSponsoredAgent = function(agentId, sponsoredAgentId){
      return $http
        .get(`${API_VARS.path}/agents/${agentId}/sponsoredAgents/${sponsoredAgentId}`)
        .then(apiHelpers.handleResponse)
        .catch(apiHelpers.handleError);
    };

    service.getBrokerage = function(agentId){
      return $http
        .get(API_VARS.path+'/agents/'+agentId+'/brokerage')
        .then(apiHelpers.handleResponse)
        .catch();
    };

    service.searchHomes = function(agentId, homeownerNameOrStreet, limit, offset, sortBy, order){
      let params = {homeownerNameOrStreet, limit, offset, sortBy, order};

      return $http
        .get(`${API_VARS.path}/agents/${agentId}/homes/search`, {params: params})
        .then(apiHelpers.handleResponse)
        .catch(apiHelpers.handleError);
    };

    service.needsCMA = function(agentId){
      return $http
        .get(API_VARS.path+'/agents/'+agentId+'/homes/needsCMA')
        .then(apiHelpers.handleResponse)
        .catch(apiHelpers.handleError);
    };

    service.countHomes = function(agentId, where){
      where = where || {};

      return $http
        .get(API_VARS.path+'/agents/'+agentId+'/homes/countHomes', {params: {where: where}})
        .then(apiHelpers.handleResponse)
        .catch(apiHelpers.handleError);
    };

    service.getCurrentUser = function(){
      return $http
        .get(API_VARS.path+'/agents/currentUser')
        .then(apiHelpers.handleResponse)
        .catch(apiHelpers.handleError);
    };

    service.sharedClients = function(agentId){
      return $http
        .get(API_VARS.path+`/agents/${agentId}/sharedClients`)
        .then(apiHelpers.handleResponse)
        .catch(apiHelpers.handleError);
    };

    service.acceptTerms = function(agentId){
      return $http
        .put(API_VARS.path+`/agents/${agentId}/acceptTerms`)
        .then(apiHelpers.handleResponse)
        .catch(apiHelpers.handleError);
    };

    return service;
  }])

  .factory('OfficeService', ['API_VARS', '$http', '$q', 'HelperService', 'AdminApiHelperService', function(API_VARS, $http, $q, helpers, apiHelpers){
    return new BaseAPIFactory('offices', API_VARS, $http, $q, helpers, apiHelpers);
  }])

  .factory('BrokerageService', ['API_VARS', '$http', '$q', 'HelperService', 'AdminApiHelperService', function(API_VARS, $http, $q, helpers, apiHelpers){
    var service = new BaseAPIFactory('brokerages', API_VARS, $http, $q, helpers, apiHelpers);

    service.getOffices = function(brokerageId){
      return $http
        .get(API_VARS.path+'/brokerages/'+brokerageId+'/offices')
        .then(apiHelpers.handleResponse)
        .catch(apiHelpers.handleError);
    };

    return service;
  }])

  .factory('RealEstateAgentService', ['API_VARS', '$http', '$q', 'HelperService', 'AdminApiHelperService', function(API_VARS, $http, $q, helpers, apiHelpers){
    return new BaseAPIFactory('realEstateAgents', API_VARS, $http, $q, helpers, apiHelpers);
  }])

  .factory('LoanService', ['API_VARS', '$http', '$q', 'HelperService', 'AdminApiHelperService', function(API_VARS, $http, $q, helpers, apiHelpers){
    return new BaseAPIFactory('homeLoans', API_VARS, $http, $q, helpers, apiHelpers);
  }])

  .factory('UserService', ['API_VARS', '$http', '$q', 'HelperService', 'AdminApiHelperService', function(API_VARS, $http, $q, helpers, apiHelpers){
    var service = new BaseAPIFactory('users', API_VARS, $http, $q, helpers, apiHelpers);

    service.getUserHomes = function(userId){
      return $http
        .get(`${API_VARS.path}/users/${userId}/userHomesList`)
        .then(apiHelpers.handleResponse)
        .catch(apiHelpers.handleError);
    };

    service.getLeads = function(agentId){
      if(!agentId) throw 'AgentId is required for client search.';

      let params = {filter: {where: {agentId: agentId, leadSource: { neq: null }}}};

      return service.getAll(params);
    };

    service.getUsersWithEmailIssues = function(agentId){
      if(!agentId) throw 'AgentId is required for client search.';

      let params = {filter: {where: {agentId: agentId, hasEmailIssues: true}}};

      return service.getAll(params);
    };

    return service;
  }])

  .factory('UserHomesService', ['API_VARS', '$http', '$q', 'HelperService', 'AdminApiHelperService', function(API_VARS, $http, $q, helpers, apiHelpers){
    var service = new BaseAPIFactory('userHomes', API_VARS, $http, $q, helpers, apiHelpers);

    service.updateDigestStatus = function(userHomeId, digestStatus){
      return $http
        .put(`${API_VARS.path}/userHomes/${userHomeId}/updateDigestStatus`, { digestStatus: digestStatus })
        .then(apiHelpers.handleResponse)
        .catch(apiHelpers.handleError);
    }

    return service;
  }])

  .factory('HomeActivity', ['API_VARS', '$http', '$q', 'HelperService', 'AdminApiHelperService', function(API_VARS, $http, $q, helpers, apiHelpers){
    var service = new BaseAPIFactory('homeActivities', API_VARS, $http, $q, helpers, apiHelpers);

    service.getAgentActivity = function(id){
      return service.getActivity({'agentId':id});
    };

    service.getUserActivity = function(id){
      return service.getActivity({'userId':id});
    };

    service.getHomeActivity = function(id){
      return service.getActivity({'homeId':id});
    };

    service.getUserHomeActivity = function(userId,homeId){
      return service.getActivity({'userId':userId,'homeId':homeId});
    };

    service.getCmaRequest = function(homeId){
      const params = {
        filter: {
          where: {
            homeId: homeId,
            event: 'cma-request',
          },
          order: 'created DESC',
        }
      };

      return $http
        .get(API_VARS.path+'/homeActivities', {params: params})
        .then(apiHelpers.handleResponse)
        .catch(apiHelpers.handleError);
    };

    service.getActivity = function(where, include, limit){
      var where = where || {};
      var include = include || 'user';
      var params = {
        filter: {
          where: where,
          include: include,
          order: 'created DESC',
          limit: limit || 200
        }
      };

      return $http
        .get(API_VARS.path+'/homeActivities', {params: params})
        .then(apiHelpers.handleResponse)
        .catch(apiHelpers.handleError);
    };

    service.trackHome = function(args){

      return $http
        .post(API_VARS.path+'/homeActivities/track/', args)
        .then(apiHelpers.handleResponse)
        .catch(apiHelpers.handleError);
    };

    return service;
  }])


  .factory('HomeService', ['API_VARS', '$http', '$q', 'HelperService', 'AdminApiHelperService', function(API_VARS, $http, $q, helpers, apiHelpers){
    var service = new BaseAPIFactory('homes', API_VARS, $http, $q, helpers, apiHelpers);

    service.saveAnswer = function(question, answer, homeId) {
      var args = {
        question: question,
        answer: answer
      };

      return $http.post(API_VARS.path + '/homes/' + homeId + '/addAnswer', args)
        .then(apiHelpers.handleResponse)
        .catch(apiHelpers.handleError)
    };

    service.saveAnswers = function(answers, homeId) {
      var args = {answers};

      return $http.post(API_VARS.path + '/homes/' + homeId + '/addAnswers', args)
        .then(apiHelpers.handleResponse)
        .catch(apiHelpers.handleError)
    };

    service.deleteAnswer = function (answerId, homeId) {
      return $http.delete(API_VARS.path + '/homes/' + homeId + '/answerData/' + answerId)
        .then(apiHelpers.handleResponse)
        .catch(apiHelpers.handleError)
    };

    service.getAnswers = function (homeId) {
      return $http.get(API_VARS.path + '/homes/' + homeId + '/answerData')
        .then(apiHelpers.handleResponse)
        .catch(apiHelpers.handleError)
    };

    service.sendDigestTest = function(homeId, email){
      var args = {};

      if(!homeId || !email)
        return $q.reject('Home and email are required to send a digest test.');

      args.email = email;

      return $http
        .post(API_VARS.path+'/homes/'+homeId+'/testDigest', args)
        .then(apiHelpers.handleResponse)
        .catch(apiHelpers.handleError);
    };

    service.sendDigest = function(id, args){
      var defaults = {
        users: []
      };

      var args = _.merge(defaults, args);

      if(!args.users.length)
        return $q.reject('Users are required to send digest.');

      return $http
        .post(API_VARS.path+'/homes/'+id+'/digest', args)
        .then(apiHelpers.handleResponse)
        .catch(apiHelpers.handleError);
    };

    service.addUserToHome = function(homeId, userParams){
      return $http
        .post(API_VARS.path+'/homes/'+homeId+'/addUser', {userParams: userParams})
        .then(apiHelpers.handleResponse)
        .catch(apiHelpers.handleError);
    },

    service.lookup = function(args){
      var args = args || {};

      return $http
        .get(API_VARS.path+'/homes/lookup', { params: args })
        .then(apiHelpers.handleResponse)
        .catch(apiHelpers.handleError);
    };

    service.getDetailedHome = function(homeId){
      return $http
        .get(API_VARS.path+'/homes/'+homeId+'/detailed/')
        .then(apiHelpers.handleResponse)
        .catch(apiHelpers.handleError);
    };

    service.getUsers = function(homeId){
      return $http
        .get(API_VARS.path+'/homes/'+homeId+'/users/')
        .then(apiHelpers.handleResponse)
        .catch(apiHelpers.handleError);
    };

    service.lookupByDatasource = function(args){
      var args = args || {};

      // The api should handle this logic in future
      if(args.source === 'homebot')
        return service.getDetailedHome(args.homeId);

      return $http
        .get(API_VARS.path+'/homes/lookup/datasource', { params: args })
        .then(apiHelpers.handleResponse)
        .catch(apiHelpers.handleError);
    };

    service.updateExternalData = function(id){
      return $http
        .post(API_VARS.path+'/homes/'+id+'/updateExternalData')
        .then(apiHelpers.handleResponse)
        .catch(apiHelpers.handleError);
    };

    service.recompileHome = function(id){
      return $http
        .post(API_VARS.path+'/homes/'+id+'/recompileHome')
        .then(apiHelpers.handleResponse)
        .catch(apiHelpers.handleError);
    };

    service.deleteLoans = function(id){
      return $http
        .delete(API_VARS.path+'/homes/'+id+'/rloans')
        .then(apiHelpers.handleResponse)
        .catch(apiHelpers.handleError);
    };

    service.agentCMA = function(id, cma){
      return $http
        .post(API_VARS.path+'/homes/'+id+'/agentCMA', cma)
        .then(apiHelpers.handleResponse)
        .catch(apiHelpers.handleError);
    };

    service.createHome = function(args){
      return $http
        .post(API_VARS.path+'/homes/createHome', args)
        .then(apiHelpers.handleResponse)
        .catch(apiHelpers.handleError);
    };

    service.createManyHomes = function(args){
      return $http
        .post(API_VARS.path+'/homes/createManyHomes', args)
        .then(apiHelpers.handleResponse)
        .catch(apiHelpers.handleError);
    };

    service.updateHomeProperties = function(data, homeId){
      var args = {data: data};

      return $http
        .post(API_VARS.path+'/homes/'+homeId+'/updateHome', args)
        .then(apiHelpers.handleResponse)
        .catch(apiHelpers.handleError);
    };

    service.resetCMA = function(homeId){
      return $http
        .post(API_VARS.path+'/homes/'+homeId+'/resetCMA')
        .then(apiHelpers.handleResponse)
        .catch(apiHelpers.handleError);
    };

    return service;
  }])

  .factory('AdminApiHelperService', ['$q', 'UtilService', 'HelperService', 'AuthForwarder', '$state', '$stateParams', function($q, utils, helpers, AuthForwarder, $state, $stateParams){

    return {
      handleResponse: function(response){
        if(utils.isValidResponse(response))
          return response.data;
        else
          return $q.reject(helpers.parseAPIError(response));
      },

      handleError: function(response){
        if(!response || !response.status)
          return $q.reject('An error has occurred getting the data.');

        if(response.status === 401){
          AuthForwarder.setForwardState($state.current.name, $stateParams);
          $state.go('login');
        }

        return $q.reject(helpers.parseAPIError(response));
      }
    }
  }]);



function BaseAPIFactory(endpoint, API_VARS, $http, $q, helpers, apiHelpers){

  if(!endpoint)
    throw 'An endpoint name is required';

  this.endpoint = endpoint;

  return {
    add: function(args){
      if(!args)
        return $q.reject('Add arguments are required.');

      return $http.post(API_VARS.path+'/'+endpoint, args)
        .then(apiHelpers.handleResponse)
        .catch(apiHelpers.handleError);
    },

    count: function(args){
      args = args || {};

      return $http.get(API_VARS.path+'/'+endpoint+'/count', { params:args })
        .then(apiHelpers.handleResponse)
        .catch(apiHelpers.handleError);
    },

    findOne: function(args){
      if(!args)
        return $q.reject('Search parameters are required.');

      return $http.get(API_VARS.path+'/'+endpoint+'/findOne', { params:args })
        .then(apiHelpers.handleResponse)
        .catch(apiHelpers.handleError);
    },

    getAll: function(args){
      var args = args || {};

      return $http.get(API_VARS.path+'/'+endpoint, { params: args })
        .then(apiHelpers.handleResponse)
        .catch(apiHelpers.handleError);
    },

    getOne: function(id, args){
      var args = args || {};

      if(!id)
        return $q.reject('ID is required.');

      return $http.get(API_VARS.path+'/'+endpoint+'/'+id, { params: args })
        .then(apiHelpers.handleResponse)
        .catch(apiHelpers.handleError);
    },

    remove: function(id){
      if(!id)
        return $q.reject('No ID passed in');

      return $http.delete(API_VARS.path+'/'+endpoint+'/'+id)
        .then(apiHelpers.handleResponse)
        .catch(apiHelpers.handleError);
    },

    save: function(args, id){
      var args = args || {};

      if(!id)
        return $q.reject('ID is required.');

      return $http.put(API_VARS.path+'/'+endpoint+'/'+id, args)
        .then(apiHelpers.handleResponse)
        .catch(apiHelpers.handleError);
    }
  };
}
